import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const RATE_CARDS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('RATE_CARDS');
export const RATE_CARDS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	RATE_CARDS_CRUD_ACTION_CONSTANTS
);
